import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './lib/i18n'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 2, // 2 minutes
      retry: 1,
    },
  },
})

// Theme bootstrap: explicit user choice wins; otherwise follow the OS
// (prefers-color-scheme), reacting live while no explicit choice is set.
const systemDark = window.matchMedia('(prefers-color-scheme: dark)')

function storedDarkPreference(): boolean | null {
  try {
    const parsed = JSON.parse(localStorage.getItem('varia-auth') || '')
    const value = parsed?.state?.isDarkMode
    return typeof value === 'boolean' ? value : null
  } catch {
    return null
  }
}

function applyTheme() {
  const stored = storedDarkPreference()
  const dark = stored ?? systemDark.matches
  document.documentElement.classList.toggle('dark', dark)
}

applyTheme()
systemDark.addEventListener('change', () => {
  if (storedDarkPreference() === null) applyTheme()
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>
)
